import { axios } from '@/lib/axios';

export const APIresendVerifyEmail = (): Promise<string> => {
    return axios.post('/auth/send-email-address-verification-email');
};
